<div class="main no-padding">
  <header-menu></header-menu>

  <div class="center-content internal-registration-establishment fade-in-animation">
    <div class="card area-to-overlay offer-edit">
      <div class="card-content" *ngIf="offer">

        <h1 class="no-margin">Editar proposta</h1>

        <p>Descreva o benefício a ser oferecido aos clientes <b>{{offer.application_name}}</b>.</p>

        <div class="responsive-columns" *ngIf="offerSlug !== 'allya'">
          <div class="only-input-check checkbox-nice">
            <input
              type="checkbox"
              id="offer-participation"
              [(ngModel)]="offer.allya_offer">
            <label for="offer-participation">Utilizar a mesma proposta de <b>Allya</b></label>
          </div>
        </div>

        <div class="responsive-columns">
          <div>
            <label>
              {{ 'REGISTRATION.OFFER.OFFER_TITLE_LABEL' | translate }}<br/>
              <input [disabled]="offer.allya_offer" class="form-control" placeholder="Título da proposta" [(ngModel)]="offer.title"/>
              <small class="offer-sample">Ex: {{ getOfferTitleSample() }}</small>
            </label>
          </div>
        </div>

        <div class="responsive-columns">
          <div>
            <label>
              {{ 'REGISTRATION.OFFER.OFFER_TERMS_LABEL' | translate }}<br/>
              <ckeditor (ready)="onEditorReady($event)" [readOnly]="!!offer.allya_offer" [config]="config" [(ngModel)]="offer.term"></ckeditor>
              <small class="offer-sample">Ex: {{ getOfferTextSample() }}</small>
            </label>
          </div>
        </div>

        <div class="responsive-columns">
          <div>

            <label>{{ 'REGISTRATION.OFFER.OFFER_CONTACT_LABEL' | translate }}</label>
            <p class="text">{{ 'REGISTRATION.OFFER.OFFER_CONTACT_PHRASE1' | translate }}
              <input
                class="inline"
                type="text"
                [disabled]="offer.allya_offer"
                [(ngModel)]="offer.contact.name">
              {{ 'REGISTRATION.OFFER.OFFER_CONTACT_PHRASE2' | translate }}

              <input
                class="inline"
                type="text"
                [disabled]="offer.allya_offer"
                [(ngModel)]="offer.contact.phone"
                [textMask]="{mask: telephoneMask}">
              {{ 'REGISTRATION.OFFER.OFFER_CONTACT_PHRASE3' | translate }}
            </p>
          </div>
        </div>

        <div class="responsive-columns">
          <div>
            <label>
              Ticket médio<br/>
              <input
                class="form-control"
                placeholder="Ticket médio"
                currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                [(ngModel)]="offer.purchase_value"
                [disabled]="offer.allya_offer" />
              <small class="offer-sample">Aqui você deve colocar qual o gasto médio dos seus clientes no seu
                estabelecimento.
              </small>
            </label>
          </div>
        </div>

        <div class="responsive-columns">
          <div>
            <label>
              Economia média<br/>
              <input
                class="form-control"
                placeholder="Economia média"
                currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                [(ngModel)]="offer.purchase_economy"
                [disabled]="offer.allya_offer" />
              <small class="offer-sample">Quanto o cliente economiza após usufruir da proposta?</small>
            </label>
          </div>
        </div>

        <div class="responsive-columns">
          <div class="buttons-actions-colab-form" *ngIf="!isLoading">
            <button class="btn btn-orange" (click)="updateEstablishment()">Salvar alterações</button>
          </div>
        </div>

        <div class="loading-overlay" *ngIf="!offer || isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
